import './StatsCards.css';

const StatsCards = ({ stats }) => {
  const getCaseStats = caseName => {
    return (
      stats.find(stat => stat._id === caseName) || { count: 0, successCount: 0, errorCount: 0 }
    );
  };

  const openaiStats = getCaseStats('openai');
  const pythonStats = getCaseStats('python');
  const motiveStats = getCaseStats('motive');

  const totalLogs = stats.reduce((sum, stat) => sum + stat.count, 0);
  const totalSuccess = stats.reduce((sum, stat) => sum + stat.successCount, 0);
  const totalErrors = stats.reduce((sum, stat) => sum + stat.errorCount, 0);

  return (
    <div className="stats-cards">
      <div className="stats-row">
        <div className="stat-card total">
          <h3>Total Logs</h3>
          <div className="stat-number">{totalLogs}</div>
          <div className="stat-details">
            <span className="success">Success: {totalSuccess}</span>
            <span className="error">Errors: {totalErrors}</span>
          </div>
        </div>

        <div className="stat-card openai">
          <h3>OpenAI Case</h3>
          <div className="stat-number">{openaiStats.count}</div>
          <div className="stat-details">
            <span className="success">Success: {openaiStats.successCount}</span>
            <span className="error">Errors: {openaiStats.errorCount}</span>
          </div>
        </div>

        <div className="stat-card python">
          <h3>Python Case</h3>
          <div className="stat-number">{pythonStats.count}</div>
          <div className="stat-details">
            <span className="success">Success: {pythonStats.successCount}</span>
            <span className="error">Errors: {pythonStats.errorCount}</span>
          </div>
        </div>

        <div className="stat-card motive">
          <h3>Motive Case</h3>
          <div className="stat-number">{motiveStats.count}</div>
          <div className="stat-details">
            <span className="success">Success: {motiveStats.successCount}</span>
            <span className="error">Errors: {motiveStats.errorCount}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsCards;
